module.exports = __webpack_public_path__ + "static/media/salon.5c96aacc.svg";